import chatService from './chatService';

// 읽음 상태는 캐시하지 않는다. 같은 조회가 끝날 때까지만 Promise를 공유한다.
const chatStatusRequests = new Map();
const peerCheckRequests = new Map();

function shareRequest(requests, key, fetchRequest) {
  if (requests.has(key)) return requests.get(key);
  const request = fetchRequest().finally(() => requests.delete(key));
  requests.set(key, request);
  return request;
}

// 키만 정규화하고 실제 HTTP 파라미터는 그대로 보낸다.
function paramsKey(params) {
  return JSON.stringify(
    Object.keys(params).sort().map((key) => [key, String(params[key])]),
  );
}

export function getReservationChatStatus(params) {
  const ids = [...new Set(String(params.reservationIds ?? '')
    .split(',').map((id) => id.trim()).filter(Boolean))].sort();
  if (ids.length === 0) return Promise.resolve({ data: { data: [] } });
  const key = paramsKey({ ...params, reservationIds: ids.join(',') });
  return shareRequest(chatStatusRequests, key, () =>
    chatService.getReservationChatStatus(params),
  );
}

export function getPeerChatCheck(params) {
  // roomId뿐 아니라 상대 업체/업종도 구분하여 서로 다른 읽음 상태를 합치지 않는다.
  return shareRequest(peerCheckRequests, paramsKey(params), () =>
    chatService.getPeerChatCheck(params),
  );
}
